import { styled, Text, spacing } from '@thg-commerce/gravity-theme'

export const ProductAlternativesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${(props) => props.theme.site.siteWidth};
  margin: 0 auto ${spacing(3)} auto;
  padding: 0 ${spacing(2)} ${spacing(3)} ${spacing(2)};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.darker};
`

export const ProductComingSoonTitle = styled.h2`
  ${Text('large1', 'default')};
  padding: ${spacing(1)};
  text-align: center;
`

export const WishlistButtonWrapper = styled.div`
  margin-top: ${spacing(1)};
  text-align: center;
`
